<template>
    <div id="loading_hint" class="loading__container">
        <div class="loading__box">
            <v-progress-circular
                indeterminate
                size="18"
                width="2"
                color="#2366f8"
            />
            <span class="loading__text">
                {{ text }}
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'loading-hint',

    props: {
        text: {
            type: String,
            required: true
        },
    },
}
</script>

<style lang="scss" scoped>
@import '../../../css/mixin.scss';

.loading {
    &__container {
        position: fixed;
        z-index: 998;
        left: 35%;
        top: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 8px;

        @include laptop {
            left: 50%;
        }
    }

    &__box {
        background-color: #ffffff;
        width: 100%;
        height: 40px;
        padding: 0 12px;      
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;

        &::after {
            content: '';
            position: absolute;
            top: -3px; 
            bottom: -3px;
            left: -3px; 
            right: -3px;
            background-image: linear-gradient(to right, #2366f8 0%, #2cfde1 100%);
            z-index: -1;
            border-radius: 8px;
        }
    }

    &__text {
        margin: 0 0.8rem;
        font-size: 12px;
        color: #121624;
    }
}
</style>